// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qz08n","colBig":"styles_colBig__HxVvQ","colSmall":"styles_colSmall__19yfY","shopifyNameWrapper":"styles_shopifyNameWrapper__19_BT"};